import { render, staticRenderFns } from "./svgFacebook.vue?vue&type=template&id=fff86852&scoped=true"
import script from "./svgFacebook.vue?vue&type=script&lang=js"
export * from "./svgFacebook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff86852",
  null
  
)

export default component.exports